<template>
  <div class="list-member">
    <!-- <label for="">Nhóm 1</label> -->
    <div class="display-flex justify-content-between margin-bottom-20">
      <div class="wrap-left display-flex">
        <div class="item item__key input-custom-icon mr-3 color_bg_gray_light border-rd-20">
          <input v-model.lazy="paramQueryData.keyword" v-debounce="300" type="text" placeholder="Tìm kiếm"
            class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 padding-right-30" />
          <i class="icon-search font-size-16 primary-color"></i>
        </div>
        <b-form-select v-model="paramQueryData.type" :options="listType" class="select-sm"></b-form-select>
      </div>
    </div>
    <b-list-group>
      <div v-if="listDataLessonClassSchool.length > 0">
        <b-list-group-item v-for="(item, index) of listDataLessonClassSchool" :key="index">
          <div class="display-flex-center cg-1">
            <img class="icon-link mb-4" width="20" src="@/assets/img/book-icon.png" />
            <div class="display-flex-column">
              <h6 v-if="item.type == 2">
                <router-link :to="{
                  path: 'bai-giang-dien-tu-da-giao',
                  query: { id: item.id, name: item.name },
                }" target="_blank" class="text-default" style="color: green; cursor: pointer">
                  {{ item.name }}
                </router-link>
              </h6>
              <h6 v-else-if="item.type == 3">
                <router-link :to="{
                  path: 'de-thi-da-giao',
                  query: { lessonId: item.id, examId: 0, name: item.name },
                }" target="_blank" class="text-default" style="color: green; cursor: pointer">
                  {{ item.name }}
                </router-link>
              </h6>
              <h6 v-else>
                <router-link :to="{
                  path: 'ke-hoach-da-giao',
                  query: { id: item.id, name: item.name },
                }" target="_blank" class="text-default" style="color: green; cursor: pointer">
                  {{ item.name }}
                </router-link>
              </h6>

              <div>
                Nội dung: {{ item.description }}
              </div>
            </div>
          </div>
        </b-list-group-item>
      </div>
      <div v-else class="text-center">Chưa có dữ liệu hiển thị</div>
    </b-list-group>
    <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
      :per-page="paramQueryData.pageSize" first-number last-number></b-pagination>
  </div>
</template>

<script>
import { listLessonClassSchoolGroupService } from "./../../_api/lessonClassSchoolGroupServices";
import debounce from "@/directives/debounce";
export default {
  directives: { debounce },
  props: {
    classSchoolGroupId: {
      type: Number,
      default: 0,
    },
    typeShowTabRight: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    classSchoolGroupId() {
      this.getListLessonClassSchoolGroup();
    },
    "paramQueryData.keyword": "getListLessonClassSchoolGroup",
    "paramQueryData.type": "getListLessonClassSchoolGroup",
    "paramQueryData.pageIndex": "getListLessonClassSchoolGroup",
  },
  mounted() {
    this.getListLessonClassSchoolGroup();
  },
  data() {
    return {
      paramQueryData: {
        keyword: "",
        type: 0,
        pageIndex: 1,
        pageSize: 5,
        groupId: 0,
      },
      listType: [
        { value: 0, text: "Loại tài liệu - tất cả" },
        { value: 2, text: "Bài giảng điện tử" },
        { value: 3, text: "Bài tập/ bài kiểm tra" },
        { value: 4, text: "Kế hoạch bài dạy" },
      ],
      listDataLessonClassSchool: [],
      totalRecords: 0,
    };
  },
  methods: {
    getListLessonClassSchoolGroup() {
      let self = this;
      this.paramQueryData.groupId = this.classSchoolGroupId;

      listLessonClassSchoolGroupService(this.paramQueryData).then((res) => {
        if (res && res.data && !res.errors) {
          self.listDataLessonClassSchool = res.data.list;
          self.totalRecords = res.data.paging.totalRecords;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-bottom-20 {
  margin-bottom: 20px;
}

.list-group {
  .list-group-item {
    border-top: 0;
    border-left: 0;
    border-right: 0;
  }
}

.pagination {
  position: absolute;
  width: 100%;
  bottom: 10px;
}

.list-group {
  overflow: auto;
  height: 22rem;
}

.pagination {
  margin-bottom: 15px;
}

h6 {
  margin: 0;
}

.padding-right-30 {
  padding-right: 30px !important;
}
</style>